module.exports = __webpack_public_path__ + "media/custom-font-icon/icomoon-e27c61dd.eot";